module.exports = __webpack_public_path__ + "assets/img/bg.2c097432.png";